import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import throttle from 'lodash/throttle';
import getRemBase from 'propel/getRemBase';

let previousWindowSize = window.innerWidth; // eslint-disable-line no-unused-vars
let resizeTimer; // eslint-disable-line no-unused-vars
const openEvent = new Event('navigation-opened');
const closeEvent = new Event('navigation-closed');

const scrollableElementsDesktop = document.querySelectorAll(
	'.block-navigation .block-navigation-submenu'
);

const scrollableElementsMobile = document.querySelectorAll(
	'.block-navigation__menu-inner'
);

const navigationBlocks = document.querySelectorAll('.block-navigation');

const navigationHamburgers = document.querySelectorAll(
	'.block-navigation__hamburger'
);

const toggleNavigationHamburger = (e) => {
	let currentNavigationHamburger = e?.currentTarget ?? e;

	if (e?.detail?.navigationHamburger) {
		currentNavigationHamburger = e.detail.navigationHamburger;
	}

	if (!currentNavigationHamburger) {
		return;
	}

	currentNavigationHamburger.classList.toggle('active');

	if (currentNavigationHamburger.classList.contains('active')) {
		window.dispatchEvent(openEvent);
		setFirstLevelButtonBlockOffsets();
		setNavMenuActiveClass(currentNavigationHamburger, true);
		currentNavigationHamburger.setAttribute('aria-expanded', true);

		if (window.innerWidth < 1440) {
			lockScroll();
		}
	} else {
		if (!e?.detail?.navigationHamburger) {
			window.dispatchEvent(closeEvent);
		}

		unlockScroll();

		setNavMenuActiveClass(currentNavigationHamburger, false);
		currentNavigationHamburger.setAttribute('aria-expanded', false);
	}
};

const submenuClosed = () => {
	if (window.innerWidth >= 1440) {
		unlockScroll();
	}
};

const setFirstLevelButtonBlockOffsets = () => {
	if (0 === navigationBlocks.length) {
		return;
	}

	navigationBlocks.forEach((navigationBlock) => {
		const firstLevelButtonBlocks = navigationBlock.querySelectorAll(
			'.block-navigation__menu > .wp-block-button'
		);

		if (0 === firstLevelButtonBlocks.length) {
			return;
		}

		let totalOffset = 0;

		for (let i = firstLevelButtonBlocks.length - 1; i >= 0; i--) {
			const firstLevelButtonBlock = firstLevelButtonBlocks[i];

			firstLevelButtonBlock.style.setProperty(
				'--buttonOffset',
				`${totalOffset / getRemBase()}rem`
			);

			totalOffset += firstLevelButtonBlock.offsetHeight;
		}

		navigationBlock.style.setProperty(
			'--totalButtonOffset',
			`${totalOffset / getRemBase()}rem`
		);
	});
};

const setNavMenuActiveClass = (element, navActive = null) => {
	const currentElement = element?.detail?.currentElement ?? element;
	const submenuOpen = element?.detail?.submenuOpen ?? false;
	const isSearch = element?.detail?.isSearch ?? false;
	const mobileNavigationLink = element?.detail?.mobileNavigationLink ?? null;

	if (!currentElement) {
		return;
	}

	const currentNavigationBlock = currentElement.closest('.block-navigation');

	if (!currentNavigationBlock) {
		return;
	}

	if (submenuOpen) {
		currentNavigationBlock.classList.add('block-navigation--submenu-open');
	} else {
		currentNavigationBlock.classList.remove(
			'block-navigation--submenu-open'
		);
	}

	if (isSearch) {
		currentNavigationBlock.classList.add('block-navigation--search-open');
	} else {
		currentNavigationBlock.classList.remove(
			'block-navigation--search-open'
		);
	}

	if (null === navActive) {
		if (
			currentElement.classList.contains('active') ||
			currentElement.parentElement.classList.contains('active') ||
			currentNavigationBlock.querySelector(
				'.block-navigation__hamburger.active'
			)
		) {
			navActive = true;
		} else {
			navActive = false;
		}
	}

	if (true === navActive) {
		currentNavigationBlock.classList.add('active');
		document.addEventListener('keydown', clickOffMenu);
		document.addEventListener('click', clickOffMenu);

		setNavigationOffset();
		lockScroll();
	} else {
		currentNavigationBlock.classList.remove('active');
		document.removeEventListener('keydown', clickOffMenu);
		document.removeEventListener('click', clickOffMenu);
		unlockScroll();
	}

	if (mobileNavigationLink) {
		return;
	}

	navigationBlocks.forEach((navigationBlock) => {
		if (navigationBlock !== currentNavigationBlock) {
			navigationBlock.classList.remove('active');
		}
	});
};

const lockScroll = () => {
	if (document.body.classList.contains('lock-scroll')) {
		return;
	}

	let scrollableElements = scrollableElementsMobile;

	if (window.innerWidth >= 1200) {
		scrollableElements = scrollableElementsDesktop;
	}

	scrollableElements.forEach((scrollableElement) => {
		const storedRequestAnimationFrame = window.requestAnimationFrame;
		window.requestAnimationFrame = () => 42;

		disableBodyScroll(scrollableElement, {
			reserveScrollBarGap: true,
		});
		window.requestAnimationFrame = storedRequestAnimationFrame;
	});

	document.body.classList.add('lock-scroll');
};

const unlockScroll = () => {
	document.body.classList.remove('lock-scroll');
	clearAllBodyScrollLocks();
};

const setNavigationOffset = () => {
	navigationBlocks.forEach((navigationBlock) => {
		const rect = navigationBlock.getBoundingClientRect();
		let offsetTop = rect.top;

		if (offsetTop < 0) {
			offsetTop = 0;
		}

		navigationBlock.style.setProperty(
			'--navigationVerticalOffset',
			`${offsetTop / getRemBase()}rem`
		);
	});
};

const clickOffMenu = (e) => {
	if (0 === navigationHamburgers.length) {
		return;
	}

	let closestMenu;
	let closestHamburger;

	if (e.key === undefined && e.target) {
		closestMenu = e.target.closest(
			'.block-navigation__menu, .block-navigation__mobile-buttons, .block-navigation-submenu--has-search'
		);
		closestHamburger = e.target.closest('.block-navigation__hamburger');
	}

	if (e.key && e.key !== 'Escape') {
		return;
	}

	if (
		closestMenu?.contains(e.target) ||
		closestHamburger?.contains(e.target) ||
		e?.target?.parentElement?.parentElement?.classList.contains(
			'block-tab-standard-tab'
		)
	) {
		return;
	}

	navigationHamburgers.forEach((navigationHamburger) => {
		if (navigationHamburger.classList.contains('active')) {
			toggleNavigationHamburger(navigationHamburger);
		}
	});

	window.dispatchEvent(closeEvent);
};

if (navigationHamburgers.length > 0) {
	navigationHamburgers.forEach((navigationHamburger) => {
		navigationHamburger.addEventListener(
			'click',
			toggleNavigationHamburger
		);
	});
}

const navigationResizing = () => {
	document.body.classList.add('resizing');

	if (
		(previousWindowSize >= 1200 && window.innerWidth < 1200) ||
		(previousWindowSize < 1200 && window.innerWidth >= 1200)
	) {
		clickOffMenu({ key: 'Escape' });
	}

	previousWindowSize = window.innerWidth;

	resizeTimer = setTimeout(function () {
		document.body.classList.remove('resizing');
		setNavigationOffset();
		setFirstLevelButtonBlockOffsets();
	}, 400);
};

setFirstLevelButtonBlockOffsets();

if (navigationBlocks.length > 0) {
	navigationBlocks.forEach((navigationBlock) => {
		navigationBlock.classList.add('block-navigation--initialized');
	});
}

window.addEventListener('navigation-submenu-closed', submenuClosed);
window.addEventListener('navigation-submenu-closed', setNavMenuActiveClass);
window.addEventListener('navigation-submenu-opened', setNavMenuActiveClass);
window.addEventListener(
	'toggle-navigation-hamburger',
	toggleNavigationHamburger
);
window.addEventListener('resize', throttle(navigationResizing, 100));
